module.exports = __webpack_public_path__ + "img/logout.a2fc1945.svg";